(() => {
  const controllers = new Set();
  class JohnScrollGallery {
    constructor(gallery) {
      this.gallery = gallery;
      this.section = gallery.closest('[id^="MainProduct-"]');
      this.list = gallery.querySelector('[id^="Slider-Gallery"]');
      this.thumbnails = gallery.querySelector('[id^="Slider-Thumbnails"]');
      this.dialog = gallery.querySelector('[data-john-dialog]');
      if (!this.list || !this.thumbnails || !this.dialog) return;
      this.events = new AbortController();
      this.cache = new Map();
      this.viewer = this.dialog.querySelector('[data-john-viewer-photos]');
      this.viewerThumbs = this.dialog.querySelector('[data-john-viewer-thumbs]');
      this.bar = gallery.querySelector('[data-john-mobile-purchase]');
      this.colors = gallery.querySelector('[data-john-colors]');
      document.querySelector('.announcement-bar-section slideshow-component')?.pause?.();
      this.list.tabIndex = 0;
      this.list.setAttribute('aria-label', gallery.getAttribute('aria-label'));
      const options = { signal: this.events.signal };
      // Keep the options at the same viewport position while media above them change height.
      const rememberSelection = event => {
        const control = event.target.closest('.globo-swatch-product-detail, variant-selects');
        if (this.changingGalleryColor || innerWidth >= 750 || !control || !event.target.closest('label, input, select, button')) return;
        this.colorAnchor = null;
        // Capture before the radio receives focus; focusing may itself move the viewport.
        const anchor = event.target.closest('li[data-value]') || control;
        if (event.type === 'click' && this.selectionAnchor?.control === anchor && performance.now() < this.selectionAnchor.until) { this.schedule(); return; }
        const value = anchor.dataset.value;
        this.selectionAnchor = { control: anchor, selector: value ? '.globo-swatch-product-detail li[data-value="' + CSS.escape(value) + '"]' : '.globo-swatch-product-detail, variant-selects', top: anchor.getBoundingClientRect().top, until: performance.now() + 1800 };
        this.schedule();
      };
      this.section.addEventListener('pointerdown', rememberSelection, { ...options, capture: true });
      this.section.addEventListener('click', rememberSelection, { ...options, capture: true });
      window.addEventListener('touchmove', () => { this.selectionAnchor = null; this.colorAnchor = null; }, { ...options, passive: true });
      window.addEventListener('wheel', () => { this.selectionAnchor = null; this.colorAnchor = null; }, { ...options, passive: true });
      gallery.setActiveMedia = (id, prepend) => this.navigate(id, prepend, false);
      gallery.setActiveThumbnail = thumbnail => this.highlight(this.thumbnails, thumbnail);
      gallery.addEventListener('click', event => {
        const detail = event.target.closest('[data-detail-photo]');
        const photo = event.target.closest('[data-john-enlarge]');
        const thumb = event.target.closest('[data-target] button');
        if (detail || photo) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(detail || photo, Boolean(detail));
        } else if (thumb && this.thumbnails.contains(thumb)) {
          event.preventDefault();
          this.navigate(thumb.closest('[data-target]').dataset.target, false);
        }
      }, { ...options, capture: true });
      gallery.addEventListener('pointerover', event => {
        if (event.pointerType !== 'mouse') return;
        const button = event.target.closest('[data-john-enlarge]');
        if (button) this.prepare(this.describe(button));
      }, options);
      // Mobile uses the document's native scroll and momentum, with no touch interception.
      this.list.addEventListener('touchstart', () => {
        if (this.autoplayBlocked) { this.videoCard = null; this.syncVideos(); }
      }, { ...options, passive: true });
      this.list.addEventListener('wheel', event => {
        if (innerWidth < 750 || this.dialog.open || event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
        const atStart = this.list.scrollTop <= 1;
        const atEnd = this.list.scrollTop + this.list.clientHeight >= this.list.scrollHeight - 1;
        if (delta < 0 && atStart || delta > 0 && atEnd) {
          event.preventDefault();
          window.scrollBy({ top: delta, behavior: 'instant' });
        }
      }, { ...options, passive: false });
      this.list.addEventListener('scroll', () => {
        if (this.mainFrame) return;
        this.mainFrame = requestAnimationFrame(() => { this.mainFrame = null; this.syncMain(); });
      }, { ...options, passive: true });
      this.viewer.addEventListener('scroll', () => {
        if (this.viewerFrame) return;
        this.viewerFrame = requestAnimationFrame(() => { this.viewerFrame = null; this.syncViewer(); });
      }, { ...options, passive: true });
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-john-close]')) this.close();
        const thumbnail = event.target.closest('[data-viewer-index]');
        if (thumbnail) this.goToViewer(Number(thumbnail.dataset.viewerIndex));
        if (event.target.closest('[data-john-previous]')) this.goToViewer(this.viewerIndex - 1);
        if (event.target.closest('[data-john-next]')) this.goToViewer(this.viewerIndex + 1);
      }, options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open && this.locked) this.finishClose(); }, options);
      const keys = event => {
        if (event.target.closest('video, input, select, textarea')) return;
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        const delta = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        if (this.dialog.open) {
          event.preventDefault();
          this.goToViewer(this.viewerIndex + delta);
        }
        else {
          const index = this.items.findIndex(item => item.dataset.mediaId === this.activeId);
          const vertical = ['ArrowUp', 'ArrowDown'].includes(event.key);
          if (vertical && (index + delta < 0 || index + delta >= this.items.length)) return;
          event.preventDefault();
          const next = this.items[Math.max(0, Math.min(this.items.length - 1, index + delta))];
          if (next) this.navigate(next.dataset.mediaId, false);
        }
      };
      this.list.addEventListener('keydown', keys, options);
      this.dialog.addEventListener('keydown', keys, options);
      this.bar?.querySelector('button').addEventListener('click', () => {
        const target = this.section.querySelector('[data-goose-size-option]') || this.section.querySelector('product-info');
        if (!target) return;
        target.scrollIntoView({ block: 'center', behavior: this.motion() });
        const choice = target.querySelector('input:checked + label, button, select, input:not([type="hidden"])');
        choice?.focus({ preventScroll: true });
      }, options);
      this.colors?.addEventListener('click', event => this.chooseColor(event), options);
      const update = () => this.schedule();
      window.addEventListener('resize', update, options);
      window.addEventListener('scroll', () => {
        if (this.pageFrame) return;
        this.pageFrame = requestAnimationFrame(() => {
          this.pageFrame = null;
          this.updateBar();
          if (innerWidth < 750 && !this.dialog.open) this.syncMain();
          else this.syncVideos();
        });
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.syncVideos(), options);
      this.mediaState = new MutationObserver(() => this.syncVideos());
      this.mediaState.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
      const cart = document.querySelector('cart-drawer');
      if (cart) this.mediaState.observe(cart, { attributes: true, attributeFilter: ['class'] });
      this.section.addEventListener('change', update, options);
      this.observer = new MutationObserver(update);
      this.observer.observe(this.list, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style'] });
      this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-goose-john-models'] });
      const info = this.section.querySelector('product-info');
      if (info) this.observer.observe(info, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled', 'style'] });
      this.resize = new ResizeObserver(update);
      [gallery, gallery.querySelector('.goose-john-details'), document.querySelector('.section-header')].filter(Boolean).forEach(e => this.resize.observe(e));
      this.refresh();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    schedule() {
      if (this.refreshFrame) return;
      this.refreshFrame = requestAnimationFrame(() => { this.refreshFrame = null; this.refresh(); });
    }
    refresh() {
      this.items = [...this.list.querySelectorAll('.product__media-item[data-media-id]')].filter(item => item.getBoundingClientRect().width > 0);
      const signature = this.items.map(item => item.dataset.mediaId).join(',');
      if (this.dialog.open && !this.detailMode && signature !== this.signature) this.close();
      this.signature = signature;
      if (this.imageSignature !== signature) {
        this.imageSignature = signature;
        const first = this.items[0];
        // Keep the selected color's first photo ahead of offscreen gallery downloads.
        this.list.querySelectorAll('.product__media-item[data-media-id]').forEach(item => {
          item.querySelectorAll('.product__media img, .deferred-media__poster img').forEach(image => {
            image.fetchPriority = item === first ? 'high' : 'auto';
            image.loading = item === first ? 'eager' : 'lazy';
            image.decoding = 'async';
          });
        });
      }
      const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
      const details = this.gallery.querySelector('.goose-john-details')?.getBoundingClientRect().height || 0;
      const mobile = innerWidth < 750;
      const viewport = window.visualViewport?.height || innerHeight;
      const height = Math.round(Math.max(240, Math.min(960, viewport - header - details - (mobile ? 112 : 44))));
      const value = height + 'px';
      if (this.gallery.style.getPropertyValue('--john-view-height') !== value) this.gallery.style.setProperty('--john-view-height', value);
      this.syncColors();
      this.restoreColorPosition();
      this.syncMain();
      this.updateBar();
      const anchor = this.selectionAnchor;
      if (anchor && innerWidth < 750 && performance.now() < anchor.until && !this.dialog.open) {
        const control = anchor.control.isConnected ? anchor.control : this.section.querySelector(anchor.selector);
        if (control) {
          const delta = control.getBoundingClientRect().top - anchor.top;
          if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'instant' });
        }
      }
    }
    colorChoices() {
      if (!this.colors) return [];
      const index = Number(this.colors.dataset.colorIndex);
      const globo = this.section.querySelector(`.globo-swatch-product-detail [data-option-index="${index}"]`);
      if (globo) return [...globo.querySelectorAll('li[data-value]')].filter(li => !li.hidden && getComputedStyle(li).display !== 'none').map(li => ({
        input: li.querySelector('input'), label: li.querySelector('label'), value: li.dataset.value
      })).filter(choice => choice.input && choice.label);
      const picker = this.section.querySelector('variant-radios, variant-selects');
      const group = picker?.querySelectorAll('fieldset, select')[index];
      if (!group) return [];
      if (group.matches('select')) return [...group.options].map(option => ({ input: group, option, value: option.value, label: option }));
      return [...group.querySelectorAll('input')].map(input => ({ input, value: input.value, label: [...group.querySelectorAll('label')].find(label => label.htmlFor === input.id) }));
    }
    syncColors() {
      if (!this.colors) return;
      const choices = this.colorChoices();
      this.colors.hidden = choices.length < 2;
      if (this.colors.hidden) return;
      const container = this.colors.querySelector('[data-john-color-choices]');
      const values = new Set(choices.map(choice => choice.value));
      [...container.children].forEach(button => { if (!values.has(button.dataset.johnColor)) button.remove(); });
      choices.forEach(choice => {
        let button = [...container.children].find(item => item.dataset.johnColor === choice.value);
        if (!button) {
          button = document.createElement('button'); button.type = 'button';
          button.className = 'goose-gallery-colors__choice'; button.dataset.johnColor = choice.value;
          const sample = document.createElement('span'); sample.className = 'goose-gallery-colors__sample'; sample.setAttribute('aria-hidden', 'true');
          button.append(sample); container.append(button);
        }
        const name = choice.label?.textContent.trim() || choice.value;
        button.setAttribute('aria-label', name); button.title = name;
        button.setAttribute('aria-pressed', String(choice.option ? choice.option.selected : choice.input.checked));
        button.disabled = choice.input.disabled || Boolean(choice.option?.disabled);
        const sample = button.firstElementChild;
        const style = choice.label && getComputedStyle(choice.label.querySelector('.swatch') || choice.label);
        const hasSwatch = style && (choice.label.closest('.globo-swatch-product-detail') || choice.label.querySelector('.swatch')) && (style.backgroundImage !== 'none' || !['rgba(0, 0, 0, 0)', 'transparent'].includes(style.backgroundColor));
        const colorKey = choice.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-_]/g, ' ');
        const fallback = { negro: '#191919', black: '#191919', gris: '#919191', gray: '#919191', 'gris nieve': '#d9d9d9', buckskin: '#ece3cd', 'cafe oscuro': '#6f4e37', 'cafe obscuro': '#6f4e37', tabaco: '#a6743c', blanco: '#f5f3ed', natural: '#e9dfc9' }[colorKey];
        const solidColor = style && !['rgba(0, 0, 0, 0)', 'transparent'].includes(style.backgroundColor);
        sample.style.backgroundColor = solidColor ? style.backgroundColor : fallback || '';
        sample.style.backgroundImage = hasSwatch ? style.backgroundImage : '';
        sample.style.backgroundBlendMode = hasSwatch ? style.backgroundBlendMode : '';
        sample.textContent = hasSwatch || fallback ? '' : name;
      });
    }
    chooseColor(event) {
      const button = event.target.closest('[data-john-color]');
      if (!button || button.disabled || button.getAttribute('aria-pressed') === 'true') return;
      const choice = this.colorChoices().find(item => item.value === button.dataset.johnColor);
      if (!choice) return;
      // Preserve the current photo position, even when the next color has fewer photos.
      const item = this.current(this.list, this.items);
      const line = (document.querySelector('.section-header')?.getBoundingClientRect().height || 0) + 12;
      if (item) {
        const rect = item.getBoundingClientRect();
        this.colorAnchor = { index: this.items.indexOf(item), progress: (line - rect.top) / rect.height, line, until: performance.now() + 2000 };
      }
      this.selectionAnchor = null;
      this.changingGalleryColor = true;
      try {
        if (choice.option) { choice.input.value = choice.value; choice.input.dispatchEvent(new Event('change', { bubbles: true })); }
        else choice.input.click();
      } finally { this.changingGalleryColor = false; }
      button.focus({ preventScroll: true });
      this.schedule();
    }
    restoreColorPosition() {
      const anchor = this.colorAnchor;
      if (!anchor || innerWidth >= 750 || performance.now() >= anchor.until || this.dialog.open) return;
      const item = this.items[Math.min(anchor.index, this.items.length - 1)];
      if (!item) return;
      const rect = item.getBoundingClientRect();
      const delta = rect.top + rect.height * anchor.progress - anchor.line;
      if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'instant' });
    }
    current(container, items) {
      const nativePage = container === this.list && innerWidth < 750;
      const header = nativePage ? document.querySelector('.section-header')?.getBoundingClientRect().height || 0 : 0;
      const line = nativePage ? header + Math.max(0, innerHeight - header) * .35 : container.getBoundingClientRect().top + container.clientHeight * .35;
      return items.find(item => { const rect = item.getBoundingClientRect(); return rect.top <= line && rect.bottom > line; }) || items.reduce((closest, item) => Math.abs(item.getBoundingClientRect().top - line) < Math.abs(closest.getBoundingClientRect().top - line) ? item : closest, items[0]);
    }
    syncMain() {
      const item = this.current(this.list, this.items || []);
      if (item && this.activeId !== item.dataset.mediaId) {
        this.activeId = item.dataset.mediaId;
        this.list.querySelectorAll('.product__media-item').forEach(card => card.classList.toggle('is-active', card === item));
        const thumbnail = [...this.thumbnails.querySelectorAll('[data-target]')].find(t => t.dataset.target === this.activeId);
        this.highlight(this.thumbnails, thumbnail);
        const status = this.gallery.querySelector('[id^="GalleryStatus"]');
        if (status && thumbnail) status.textContent = thumbnail.querySelector('button')?.getAttribute('aria-label') || '';
      }
      this.syncVideos();
    }
    setupVideo(video) {
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = true;
      video.preload = 'metadata';
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      return video;
    }
    syncVideos() {
      const container = this.dialog.open ? this.viewer : this.list;
      const cards = this.dialog.open ? this.figures || [] : this.items || [];
      const bounds = container.getBoundingClientRect();
      const top = Math.max(0, bounds.top), bottom = Math.min(innerHeight, bounds.bottom);
      const blocked = document.hidden || document.querySelector('dialog[open]:not([data-john-dialog]), cart-drawer.active, header-drawer details[open]');
      let candidate = null, best = 0;
      if (!blocked && bottom > top) cards.forEach(card => {
        if (!card.querySelector('video') && !card.querySelector('deferred-media template')?.content.querySelector('video')) return;
        const rect = card.getBoundingClientRect();
        const height = Math.min(rect.height, container.clientHeight, innerHeight);
        const visible = Math.max(0, Math.min(rect.bottom, bottom) - Math.max(rect.top, top));
        const ratio = height > 0 && rect.width > 0 ? visible / height : 0;
        if (ratio >= .5 && ratio > best) { candidate = card; best = ratio; }
      });
      this.gallery.querySelectorAll('video').forEach(video => { if (!candidate?.contains(video)) video.pause(); });
      if (candidate === this.videoCard) return;
      this.videoCard = candidate;
      if (!candidate) return;
      let video = candidate.querySelector('video');
      if (!video) {
        const deferred = candidate.querySelector('deferred-media');
        const source = deferred?.querySelector('template')?.content.querySelector('video');
        if (!source) return;
        video = this.setupVideo(source.cloneNode(true));
        deferred.setAttribute('loaded', 'true');
        deferred.append(video);
      } else this.setupVideo(video);
      this.autoplayBlocked = false;
      video.play()?.catch(() => {
        // A rejected attempt must not permanently lock out this visible video.
        if (this.videoCard === candidate) { this.videoCard = null; this.autoplayBlocked = true; }
      });
    }
    highlight(container, item) {
      container.querySelectorAll('button').forEach(button => button.removeAttribute('aria-current'));
      const button = item?.matches('button') ? item : item?.querySelector('button');
      if (!button) return;
      button.setAttribute('aria-current', 'true');
      const rect = button.getBoundingClientRect(), bounds = container.getBoundingClientRect();
      if (rect.top < bounds.top) container.scrollTop += rect.top - bounds.top;
      else if (rect.bottom > bounds.bottom) container.scrollTop += rect.bottom - bounds.bottom;
    }
    navigate(id, prepend, reveal = true) {
      const item = [...this.list.querySelectorAll('[data-media-id]')].find(card => card.dataset.mediaId === id);
      if (!item) return;
      if (prepend) {
        this.list.prepend(item);
        const thumbnail = [...this.thumbnails.querySelectorAll('[data-target]')].find(t => t.dataset.target === id);
        if (thumbnail) this.thumbnails.prepend(thumbnail);
      }
      this.refresh();
      const top = item.getBoundingClientRect().top - this.list.getBoundingClientRect().top + this.list.scrollTop;
      if (innerWidth < 750) {
        // Variant refreshes should not move someone away from the options they are choosing.
        if (reveal && !prepend) {
          const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
          window.scrollTo({ top: Math.max(0, scrollY + item.getBoundingClientRect().top - header - 12), behavior: this.motion() });
        }
      } else this.list.scrollTo({ top, behavior: prepend ? 'auto' : this.motion() });
      this.activeId = null;
      this.syncMain();
    }
    describe(button) {
      const detail = button.hasAttribute('data-detail-photo');
      const card = button.closest('.product__media-item');
      const image = detail ? button.querySelector('img') : card?.querySelector('.product__media img');
      const thumb = detail ? image : [...this.thumbnails.querySelectorAll('[data-target]')].find(t => t.dataset.target === card?.dataset.mediaId)?.querySelector('img');
      return { button, card, detail, url: button.dataset.fullUrl || button.dataset.photoUrl, width: Number(button.dataset.photoWidth), height: Number(button.dataset.photoHeight), kind: button.dataset.photoKind || 'image', preview: image?.currentSrc || image?.src, thumb: thumb?.currentSrc || thumb?.src || image?.src, title: detail ? button.dataset.photoTitle : image?.alt || '', label: button.getAttribute('aria-label') || thumb?.alt || '' };
    }
    photoUrl(photo) {
      const ratio = photo.width / photo.height;
      const target = Math.min(innerWidth - (innerWidth < 750 ? 60 : 156), 1100, (innerHeight - 170) * ratio) * Math.min(devicePixelRatio || 1, 2);
      const width = [640, 800, 1024, 1280, 1600, 1920].find(w => w >= target) || 1920;
      const url = new URL(photo.url, location.href);
      url.searchParams.set('width', Math.min(width, photo.width));
      return url.href;
    }
    prepare(photo) {
      if (!photo.url || photo.kind !== 'image') return Promise.resolve(null);
      const url = this.photoUrl(photo);
      if (this.cache.has(url)) return this.cache.get(url);
      const pending = new Promise(resolve => {
        const image = new Image(); image.decoding = 'async';
        image.onload = async () => { try { await image.decode(); } catch {} resolve(image); };
        image.onerror = () => { this.cache.delete(url); resolve(null); };
        image.src = url;
      });
      this.cache.set(url, pending);
      return pending;
    }
    open(button, detailMode) {
      this.detailMode = detailMode;
      this.opener = button;
      this.generation = (this.generation || 0) + 1;
      const generation = this.generation;
      this.photos = (detailMode ? [...this.gallery.querySelectorAll('[data-detail-photo]')] : this.items.map(item => item.querySelector('[data-john-enlarge]')).filter(Boolean)).map(b => this.describe(b));
      this.viewer.replaceChildren(); this.viewerThumbs.replaceChildren();
      this.figures = this.photos.map((photo, index) => {
        const figure = document.createElement('figure'); figure.className = 'goose-john-gallery-viewer__photo';
        let media;
        if (photo.kind === 'video') {
          const deferred = photo.card.querySelector('deferred-media');
          const source = deferred?.querySelector('video') || deferred?.querySelector('template')?.content.querySelector('video');
          if (source) { media = this.setupVideo(source.cloneNode(true)); media.preload = 'none'; media.poster = photo.preview; }
        }
        if (!media) { media = document.createElement('img'); media.src = photo.preview; media.alt = photo.title; media.width = photo.width; media.height = photo.height; media.decoding = 'async'; media.loading = 'lazy'; }
        figure.append(media);
        if (photo.detail && photo.title) { const caption = document.createElement('figcaption'); caption.textContent = photo.title; figure.append(caption); }
        this.viewer.append(figure);
        const thumbnail = document.createElement('button'); thumbnail.type = 'button'; thumbnail.dataset.viewerIndex = index; thumbnail.setAttribute('aria-label', photo.label || String(index + 1));
        const thumb = document.createElement('img'); thumb.src = photo.thumb; thumb.alt = ''; thumb.width = 56; thumb.height = 68; thumbnail.append(thumb); this.viewerThumbs.append(thumbnail);
        figure.upgrade = () => {
          if (figure.loaded || photo.kind !== 'image') return;
          figure.loaded = true; figure.setAttribute('aria-busy', 'true');
          this.prepare(photo).then(image => { if (generation !== this.generation) return; if (image) media.src = image.src; figure.removeAttribute('aria-busy'); });
        };
        return figure;
      });
      this.previousOverflow = document.body.style.overflow;
      this.locked = true; document.body.style.overflow = 'hidden';
      window.pauseAllMedia?.(); this.dialog.showModal();
      this.goToViewer(Math.max(0, this.photos.findIndex(p => p.button === button)), 'auto');
      this.visiblePhotos?.disconnect();
      this.visiblePhotos = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) entry.target.upgrade(); }), { root: this.viewer, rootMargin: '80px 0px' });
      this.figures.forEach(figure => this.visiblePhotos.observe(figure));
    }
    goToViewer(index, behavior = this.motion()) {
      index = (index + this.figures.length) % this.figures.length;
      const figure = this.figures[index];
      if (!figure) return;
      const top = figure.getBoundingClientRect().top - this.viewer.getBoundingClientRect().top + this.viewer.scrollTop;
      this.viewer.scrollTo({ top, behavior });
      figure.upgrade();
      if (behavior === 'auto') this.syncViewer();
    }
    syncViewer() {
      if (!this.dialog.open) return;
      const figure = this.current(this.viewer, this.figures);
      this.viewerIndex = this.figures.indexOf(figure);
      this.highlight(this.viewerThumbs, this.viewerThumbs.children[this.viewerIndex]);
      this.dialog.querySelector('[data-john-counter]').textContent = (this.viewerIndex + 1) + ' / ' + this.figures.length;
      this.syncVideos();
    }
    close() { this.dialog.close(); this.finishClose(); }
    finishClose() {
      if (!this.locked) return;
      this.generation++;
      this.visiblePhotos?.disconnect();
      this.dialog.querySelectorAll('video').forEach(video => video.pause());
      document.body.style.overflow = this.previousOverflow; this.locked = false;
      if (!this.detailMode) {
        const current = this.photos[this.viewerIndex];
        if (current?.card?.isConnected) { this.navigate(current.card.dataset.mediaId, false); this.opener = current.button; }
      }
      this.opener?.focus({ preventScroll: true }); this.updateBar(); this.syncVideos();
    }
    updateBar() {
      if (!this.bar) return;
      const rect = this.gallery.getBoundingClientRect();
      const button = this.section.querySelector('product-form [name="add"]');
      const bounds = button?.getBoundingClientRect();
      const purchaseVisible = bounds && bounds.top < innerHeight && bounds.bottom > 0;
      this.bar.hidden = innerWidth >= 750 || rect.bottom < 100 || rect.top > innerHeight - 100 || purchaseVisible;
      const price = this.section.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price-item--regular')?.textContent.trim();
      const output = this.bar.querySelector('[data-john-mobile-price]');
      if (price && output.textContent !== price) output.textContent = price;
    }
    destroy() {
      if (this.locked) this.close();
      this.gallery.querySelectorAll('video').forEach(video => video.pause());
      this.events?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.visiblePhotos?.disconnect(); this.mediaState?.disconnect();
      [this.mainFrame, this.viewerFrame, this.refreshFrame, this.pageFrame].forEach(frame => cancelAnimationFrame(frame));
    }
  }
  const boot = () => {
    controllers.forEach(controller => { if (!controller.gallery.isConnected) { controller.destroy(); controllers.delete(controller); } });
    document.querySelectorAll('media-gallery[data-goose-scroll]').forEach(gallery => {
      if (gallery.johnScroll) return;
      gallery.johnScroll = new JohnScrollGallery(gallery); controllers.add(gallery.johnScroll);
    });
  };
  customElements.whenDefined('media-gallery').then(boot);
  document.addEventListener('shopify:section:load', boot);
})();
